<div class="flex justify-between h-[90vh]">
  <app-side-dialog class="w-full" [fullHeight]="true" [contentMarginTop]="0" (closeDialog)="onCloseClick()">
    <div dialogHeader class="flex flex-1 items-center w-full min-w-0"></div>

    <div class="dialog-content h-full" dialogContent>
      <app-cta-analytics-dialog-content
        [adminMode]="data.adminMode"
        [analyticsNode]="data.analyticsNode"
        [briefingId]="data.briefingId ?? null"
        [campaign]="data.campaign"
        [campaignExport]="data.campaignExport"
        [campaignProcessStatus]="data.campaignAnalytics.processStatus"
        [creator]="data.analyticsNode.creator"
        [creatorBriefingMode]="data.creatorBriefingMode"
        [ctaResult]="currentCtaResult()!"
        [exportMode]="data.exportMode"
        [selectedDeliverableExecutionAnalytics]="selectedDeliverableExecutionAnalytics()"
        [selectedDeliverableId]="selectedDeliverableId()"
        [selectedDeliverableType]="selectedDeliverableType()"
        (ctaExecutionChange)="onExecutionChange($event)"
        (deliverableSelected)="deliverableSelected($event)"
        (overviewRequested)="onOverviewRequested()"
      />
    </div>
  </app-side-dialog>
</div>
